import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-surgical-history',
  templateUrl: './update-surgical-history.component.html',
  styleUrls: ['./update-surgical-history.component.css']
})
export class UpdateSurgicalHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
